import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState, useEffect } from "react";
import AddCustomer from "../pages/pay-check/addCustomer";
import PropTypes from 'prop-types';

export const CustomerDialogWrapper = ({
    buttonLabel = "Müşteri Ekle",
    buttonIcon = "pi pi-user-plus",
    buttonClassName = "",
    customerData = null,
    onCustomerSaved = () => { }
}) => {
    const [visible, setVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isKefilPanelOpen, setIsKefilPanelOpen] = useState(false); // Kefil panel durumu

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const openDialog = () => {
        setVisible(true);
    };

    const closeDialog = () => {
        setVisible(false);
        setIsKefilPanelOpen(false); // Dialog kapanırken kefil panel state'ini sıfırla
    };

    const handleCustomerAddedOrUpdated = () => {
        closeDialog();
        onCustomerSaved();
    };

    const handleKefilPanelToggle = (isOpen) => {
        setIsKefilPanelOpen(isOpen);
    };

    // Varsayılan buton stili
    const defaultButtonClass = `
        rounded-xl shadow-lg cursor-pointer 
        text-blue-700 dark:text-blue-400 
        hover:text-white dark:hover:text-white 
        border border-blue-700 dark:border-blue-500 
        hover:bg-blue-800 dark:hover:bg-blue-600 
        p-3 transition-all duration-200
        ${isMobile ? 'w-full text-sm' : ''}
    `;

    const finalButtonClass = buttonClassName || defaultButtonClass;

    const getDialogStyle = () => {
        if (isMobile) {
            return {
                width: '100vw',
                height: '100vh',
                maxWidth: 'none'
            };
        }

        return {
            width: isKefilPanelOpen ? '80vw' : '40vw',
            height: isKefilPanelOpen ? '85vh' : '85vh',
            maxWidth: isKefilPanelOpen ? '1800px' : '1400px',
            transition: 'all 300ms ease-in-out' // Smooth geçiş animasyonu
        };
    };

    return (
        <>
            <Button
                label={buttonLabel}
                icon={buttonIcon}
                onClick={openDialog}
                className={finalButtonClass}
            />

            <Dialog
                header={
                    <div className="flex items-center gap-2">
                        <i className={customerData ? "pi pi-user-edit" : "pi pi-user-plus"}></i>
                        <span>{customerData ? "Müşteri Güncelle" : "Müşteri Ekle"}</span>
                    </div>
                }
                visible={visible}
                onHide={closeDialog}
                modal
                className="customer-dialog"
                style={getDialogStyle()}
                contentStyle={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0
                }}
                position={isMobile ? "bottom" : "center"}
                blockScroll
                draggable={!isMobile}
                resizable={!isMobile}
                dismissableMask={!isMobile}
                closeOnEscape={!isMobile}
            >
                <div className="flex-1 overflow-hidden">
                    <AddCustomer
                        onClose={handleCustomerAddedOrUpdated}
                        customerData={customerData}
                        onKefilPanelToggle={handleKefilPanelToggle}
                    />
                </div>
            </Dialog>

            <style jsx global>{`
                /* Dialog stilleri */
                .customer-dialog .p-dialog {
                    margin: 0;
                    border-radius: ${isMobile ? '0' : '0.75rem'};
                    background-color: #ffffff;
                    transition: all 300ms ease-in-out; /* Dialog için geçiş animasyonu */
                }

                .dark .customer-dialog .p-dialog {
                    background-color: #111827;
                    border: 1px solid #374151;
                }

                .customer-dialog .p-dialog-header {
                    background-color: #f9fafb;
                    border-bottom: 1px solid #e5e7eb;
                    padding: ${isMobile ? '0.75rem' : '1rem 1.5rem'};
                }

                .dark .customer-dialog .p-dialog-header {
                    background-color: #1f2937;
                    border-bottom: 1px solid #374151;
                    color: #f3f4f6;
                }

                .customer-dialog .p-dialog-content {
                    padding: 0;
                    overflow: hidden;
                }

                /* Mobil için özel stiller */
                @media (max-width: 768px) {
                    .customer-dialog .p-dialog {
                        height: 100vh !important;
                        width: 100vw !important;
                        max-height: 100vh !important;
                    }

                    .customer-dialog .p-dialog-mask {
                        background-color: transparent;
                    }
                }

                /* Dialog animasyonları */
                .customer-dialog .p-dialog-enter {
                    opacity: 0;
                    transform: ${isMobile ? 'translateY(100%)' : 'scale(0.7)'};
                }

                .customer-dialog .p-dialog-enter-active {
                    opacity: 1;
                    transform: ${isMobile ? 'translateY(0)' : 'scale(1)'};
                    transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
                }

                .customer-dialog .p-dialog-exit {
                    opacity: 1;
                    transform: ${isMobile ? 'translateY(0)' : 'scale(1)'};
                }

                .customer-dialog .p-dialog-exit-active {
                    opacity: 0;
                    transform: ${isMobile ? 'translateY(100%)' : 'scale(0.7)'};
                    transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
                }

                /* Close button stilleri */
                .customer-dialog .p-dialog-header-close {
                    width: ${isMobile ? '44px' : '2rem'};
                    height: ${isMobile ? '44px' : '2rem'};
                    color: #6b7280;
                }

                .dark .customer-dialog .p-dialog-header-close {
                    color: #9ca3af;
                }

                .customer-dialog .p-dialog-header-close:hover {
                    background-color: #f3f4f6;
                }

                .dark .customer-dialog .p-dialog-header-close:hover {
                    background-color: #374151;
                }
            `}</style>
        </>
    );
};

CustomerDialogWrapper.propTypes = {
    buttonLabel: PropTypes.string,
    buttonIcon: PropTypes.string,
    buttonClassName: PropTypes.string,
    customerData: PropTypes.object,
    onCustomerSaved: PropTypes.func
};

export default CustomerDialogWrapper;